import { Wind, Wrench, Hammer, Drill, Check } from "lucide-react";
import { Reveal } from "./Reveal";
import { SERVICES } from "@/lib/site";

const ICONS = { hvac: Wind, plumbing: Wrench, carpentry: Hammer, handyman: Drill };

export const Services = () => (
  <section id="services" className="relative py-24 lg:py-36 px-6 lg:px-12" data-testid="services-section">
    <div className="max-w-[1400px] mx-auto">
      <Reveal>
        <p className="font-mono text-xs uppercase tracking-[0.4em] text-orange-500 mb-4">What we do</p>
        <h2 className="font-display text-5xl sm:text-6xl lg:text-7xl leading-[0.9] text-white uppercase">
          Our Core <span className="text-orange-500">Specialties</span>
        </h2>
        <p className="mt-4 font-mono text-xs sm:text-sm uppercase tracking-[0.2em] text-slate-400">
          Engineered solutions for residential & commercial properties
        </p>
      </Reveal>

      <div className="mt-14 grid gap-6 md:grid-cols-2">
        {SERVICES.map((s, i) => {
          const Icon = ICONS[s.id];
          return (
            <Reveal key={s.id} delay={i * 0.08}>
              <article
                data-testid={s.testid}
                className="group relative h-full bg-[#14171f] border border-white/10 hover:border-orange-500/60 transition-colors duration-300 overflow-hidden"
              >
                <div className="relative h-56 overflow-hidden">
                  <img
                    src={s.image}
                    alt={s.title}
                    loading="lazy"
                    className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#14171f] via-[#14171f]/20 to-transparent" />
                  <span className="absolute top-4 left-4 font-display text-6xl leading-none text-white/15 select-none">
                    0{i + 1}
                  </span>
                  <span className="absolute top-4 right-4 bg-[#0c0e12]/80 border border-white/10 p-2.5 text-orange-500">
                    <Icon size={20} />
                  </span>
                </div>
                <div className="p-6 lg:p-8">
                  <h3 className="font-display text-3xl tracking-wide text-white uppercase">{s.title}</h3>
                  <p className="mt-3 text-sm text-slate-400 leading-relaxed">{s.description}</p>
                  <ul className="mt-5 grid grid-cols-1 sm:grid-cols-2 gap-x-4 gap-y-2">
                    {s.features.map((f) => (
                      <li key={f} className="flex items-center gap-2 text-[11px] font-mono uppercase tracking-wider text-slate-300">
                        <Check size={14} className="text-orange-500 shrink-0" strokeWidth={3} />
                        {f}
                      </li>
                    ))}
                  </ul>
                </div>
              </article>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
